import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { cmsPageClick } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import React from "react"
import type { CreateableBannerType } from "types/cms"
import { DesktopImage, MobileImage } from "../../shared/BannerImages"

import { container } from "./Content.css"
import { ContentBlock } from "./ContentBlock"

type Props = {
  desktopImage: CreateableBannerType["desktopImage"]
  mobileImage: CreateableBannerType["mobileImage"]
  contentBlocks: CreateableBannerType["contentBlocks"]
} & CMSPageProps

export const CreateableBannerContent: React.FC<Props> = ({
  desktopImage,
  mobileImage,
  contentBlocks,
  trackingModule,
}) => {
  const { modulePosition } = trackingModule
  return (
    <div className={container}>
      <DesktopImage
        title={desktopImage?.filename ?? "title"}
        desktopImage={desktopImage}
        modulePosition={modulePosition}
      />
      <MobileImage
        title={mobileImage?.filename ?? "title"}
        mobileImage={mobileImage}
        modulePosition={modulePosition}
      />
      {contentBlocks.map((contentBlock) => {
        if (!contentBlock.link) {
          return (
            <ContentBlock
              key={contentBlock.id}
              {...contentBlock}
              trackingModule={trackingModule}
            />
          )
        }
        const handleClick = () => {
          cmsPageClick({
            ...trackingModule,
            moduleContentUrl: contentBlock.link?.href,
            moduleContentDetails: "hero_banner_clicked",
          })
          // navigateTo(contentBlock.link?.href ?? "")
        }
        return (
          <a
            key={contentBlock.id}
            target="_blank"
            title={contentBlock?.link?.title ?? ""}
            href={contentBlock.link?.href}
            rel="noreferrer"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(contentBlock.link && {
              onClick: handleClick,
            })}
          >
            <ContentBlock {...contentBlock} trackingModule={trackingModule} />
          </a>
        )
      })}
    </div>
  )
}
